
import React from 'react';
import { Card } from '@/components/ui/card';
import { Check, FileArchive, FileText, LayoutGrid, Clock, BarChart2, Download } from 'lucide-react';

const features = [
  {
    icon: Download,
    title: "Full TikTok Collection Downloads",
    description: "Download entire collections with all metadata preserved"
  },
  {
    icon: FileArchive,
    title: "One-Click ZIP Export",
    description: "Get your videos in a convenient ZIP archive format"
  },
  {
    icon: FileText,
    title: "Optional Transcripts in Excel",
    description: "Export video captions and details to spreadsheets"
  },
  {
    icon: LayoutGrid,
    title: "Dual Views",
    description: "Switch between grid and list views for easy browsing"
  },
  {
    icon: Clock,
    title: "Temporary Storage",
    description: "Your files are safely stored for 24 hours"
  },
  {
    icon: BarChart2,
    title: "Download Status Dashboard",
    description: "Monitor all your downloads in real-time"
  }
];

const KeyFeatures = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#1A1E2C] to-[#151823]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1C2538]/40 border border-[#2A3547] backdrop-blur-sm">
            <Check className="w-4 h-4 text-[#00E5FF]" />
            <span className="text-[#00E5FF] text-sm font-medium tracking-wider">
              Key Features
            </span>
          </div>

          <h2 className="text-4xl font-bold text-white mt-4 mb-6">
            Everything You Need to Manage TikTok Collections
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Powerful tools designed for TikTok power users, making content management effortless
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <Card 
              key={feature.title}
              className="group bg-[#1E2232]/60 border-gray-800 p-6 hover:bg-[#1E2232]/80 transition-all duration-300 hover:scale-105"
            >
              <div className="w-12 h-12 bg-[#00E5FF]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#00E5FF]/20 transition-colors">
                <feature.icon className="w-6 h-6 text-[#00E5FF]" />
              </div>
              <h3 className="text-lg font-medium text-white mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-400">{feature.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyFeatures;
